import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EquipmentRouteDto } from '../bo/equipment/equipmentRoute';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class EquipmentRouteService {

  private readonly http = inject(HttpClient);

  public getRoutesBySiteId(siteId: number): Observable<EquipmentRouteDto[]> {
    return this.http.get<EquipmentRouteDto[]>(
      `${environment.exploreURL}/EquipmentPath/site/${siteId}`,
      httpOptions
    );
  }

  public getRoutesByTirId(tirId: number): Observable<EquipmentRouteDto[]> {
    return this.http.get<EquipmentRouteDto[]>(
      `${environment.exploreURL}/EquipmentPath/tir/${tirId}`,
      httpOptions
    );
  }

  public getRouteById(id: number): Observable<EquipmentRouteDto> {
    return this.http.get<EquipmentRouteDto>(
      `${environment.exploreURL}/EquipmentPath/${id}`,
      httpOptions
    );
  }

  public getRoutesBySiteIdAndDateRange(siteId: number, startDate: Date, endDate: Date): Observable<EquipmentRouteDto[]> {
    return this.http.get<EquipmentRouteDto[]>(
      `${environment.exploreURL}/EquipmentPath/site/${siteId}/range?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
      httpOptions
    );
  }

  public createRoute(route: EquipmentRouteDto): Observable<EquipmentRouteDto> {
    return this.http.post<EquipmentRouteDto>(
      `${environment.exploreURL}/EquipmentPath`,
      route,
      httpOptions
    );
  }

  public updateRoute(id: number, route: EquipmentRouteDto): Observable<EquipmentRouteDto> {
    return this.http.put<EquipmentRouteDto>(
      `${environment.exploreURL}/EquipmentPath/${id}`,
      route,
      httpOptions
    );
  }

  public deleteRoute(id: number): Observable<void> {
    return this.http.delete<void>(
      `${environment.exploreURL}/EquipmentPath/${id}`,
      httpOptions
    );
  }

  public saveRoutes(routes: EquipmentRouteDto[]): Observable<EquipmentRouteDto[]> {
    if (routes.length === 0) {
      return of([]);
    }
    const requests = routes.map(route => this.createRoute(route));
    return forkJoin(requests);
  }
}
